<template>
  <v-select v-if="hasScheduleService && getScheduleOptions.length >= 1"
            :items="getScheduleOptions"
            v-model="hour"
            :label="$t('delivery.mode.deliveryTime')"
            outlined
            :hide-details="hideDetails"
            :dense="dense"
  >
  </v-select>
  <v-alert v-else-if="hasScheduleService" type="info" dense>
    {{ $t('delivery.scheduleTime.noOptions') }}
  </v-alert>
</template>

<script>
import CalendarIsActive from "@/modules/calendar/mixins/CalendarIsActive";

export default {
  name: "ScheduleTimeCombobox",
  mixins: [CalendarIsActive],
  props: {
    value: {type: String},
    hideDetails: {type: Boolean, default: false},
    dense: {type: Boolean, default: false},
  },
  data() {
    return {
      mounted: false,
    }
  },
  computed: {
    hour: {
      get() {
        return this.value
      },
      set(v) {
        console.log("ScheduleTimeCombobox.set", v)
        this.$emit('input', v)
      }
    },
    hasScheduleService(){
      return this.$store.getters.orderSystem.hasScheduleService
    },
    getScheduleOptions(){
      return this.$store.getters.orderSystem.getScheduleOptions
    }
  }
}
</script>

<style scoped>

</style>
